import type { IModuleSummary } from '@platform/core/types';
import type { IModuleFlags } from './IModuleFlags';

/**
 * Чи модуль є в робочому просторі (прототип v4 ws.modules): встановлений, вимкнений у просторі чи вимкнений глобально (ADR-027: сервер
 * тоді віддає `installed:false`, але модуль простору зберігає позицію `order` у порядку простору — модуль поза простором її не має).
 * Чиста функція.
 */
export function installedHere(module: IModuleSummary): boolean {
  const flags = module as IModuleFlags;
  return module.installed || !!flags.disabled || (!!flags.globalDisabled && flags.order != null);
}
